import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WebAppInfo } from '@app/core/constants/web-versions';
import { InAppBrowser } from '@app/core/services/in-app-browser/in-app-browser.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Device, DeviceInfo } from '@capacitor/device';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { StatusBar, Style } from '@capacitor/status-bar';
import { NavigationBar } from '@capgo/capacitor-navigation-bar';
import {
  IonRouterOutlet,
  LoadingController,
  MenuController,
  ModalController,
  NavController,
  Platform,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ADD_FILE_OPTION_NAME, EMAIL_ACCOUNT_TYPE } from './core/constants/app.enum';
import { LOCAL_IMAGES } from './core/constants/img-constants';
import { STORAGE_CONST } from './core/constants/storage-constants';
import { CLOUD_ACCOUNTS } from './core/constants/string-constants';
import { AccountsStateService } from './core/services/accounts/account-state.service';
import { AccountsService } from './core/services/accounts/accounts.service';
import { DomainService } from './core/services/domain/domain.service';
import { FirebaseCrashlyticsService } from './core/services/firebase-crashlytics/firebase-crashlytics.service';
import { GoogleService } from './core/services/google/google.service';
import { IntuneService } from './core/services/intune/intune.service';
import { LanguageService } from './core/services/language/language.service';
import { LoginAccountService } from './core/services/login-account/login-account.service';
import { CustomNavigationClient } from './core/services/msal/customNavigationClient';
import { SharedService } from './core/services/shared/shared.service';
import { StorageService } from './core/services/storage/storage.service';
import { ToastService } from './core/services/toast/toast.service';
import { UpdatePwaServiceService } from './core/services/updatePwaService/update-pwa-service.service';
import { MobileConfiguration } from './shared/interfaces/intune.interface';
import { User } from './shared/models/User';
import { NAV_BAR_COLOR, SDK_VERSION_FOR_ANDROID_15 } from './core/constants/app-constant';
import { AlertService } from './core/services/alert/alert.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [
    './styles/side-menu.scss',
    './styles/side-menu.shell.scss',
    './styles/side-menu.responsive.scss',
  ],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(IonRouterOutlet) routerOutlet: IonRouterOutlet;
  public backCount: number = 0;
  appPages = [
    {
      title: 'Add Accounts',
      url: '/app/user',
      ionicIcon: 'person-outline',
    },
  ];
  localImages = LOCAL_IMAGES;
  accountPages = CLOUD_ACCOUNTS;
  // [
  //   // {
  //   //   label: 'GoogleDrive',
  //   //   title: "Google Drive",
  //   //   url: "/auth/login",
  //   //   ionicIcon: "cloud-outline",
  //   //   isEnabled: false,
  //   //   isVisible: true
  //   // },
  //   {
  //     label: 'Box',
  //     title: "Box",
  //     url: "/auth/login",
  //     ionicIcon: "cloud-outline",
  //     isEnabled: false,
  //     isVisible: true
  //   },
  //   {
  //     label: 'OneDrive',
  //     title: "One Drive",
  //     url: "/auth/login",
  //     ionicIcon: "cloud-outline",
  //     isEnabled: false,
  //     isVisible: true
  //   },
  //   {
  //     label: 'DropBox',
  //     title: "Drop Box",
  //     url: "/getting-started",
  //     ionicIcon: "cloud-outline",
  //     isEnabled: false,
  //     isVisible: true
  //   },
  //   {
  //     label: 'Office365',
  //     title: "Office 365",
  //     url: "/getting-started",
  //     ionicIcon: "cloud-outline",
  //     isEnabled: false,
  //     isVisible: true
  //   },
  // ];

  gDrive = true;
  oneDrive = false;
  box = false;
  dropBox = false;
  office365 = false;

  textDir = 'ltr';
  deviceInfo: DeviceInfo;
  appVersion: string;
  cloudStorageToggle = true;
  subscription: Subscription;
  isCloudLoggedIn = false;

  private readonly _destroying$ = new Subject<void>();
  constructor(
    private accountSvc: AccountsService,
    private menuCtrl: MenuController,
    private navCtrl: NavController,
    private broadcastService: MsalBroadcastService,
    private accounts: AccountsService,
    private storageSvc: StorageService,
    private iab: InAppBrowser,
    private msalService: MsalService,
    public loadingCtrl: LoadingController,
    private domainSvc: DomainService,
    private platform: Platform,
    private route: ActivatedRoute,
    public sharedSvc: SharedService,
    public loginAccountService: LoginAccountService,
    private webAppInfo: WebAppInfo,
    private updatePwaServiceService: UpdatePwaServiceService,
    private languageService: LanguageService,
    private zone: NgZone,
    private firebaseCrashlyticsService: FirebaseCrashlyticsService,
    public intuneService: IntuneService,
    private cdrRef: ChangeDetectorRef,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
    private googleService: GoogleService,
    private accountStateService: AccountsStateService,
    private alertService: AlertService
  ) {
    this.msalService.instance.setNavigationClient(
      new CustomNavigationClient(this.iab, this.sharedSvc)
    );
    this.appVersion = this.webAppInfo.appVersion;
    this.updatePwaServiceService.checkForUpdates();
  }

  getCloudStorageConfig() {
    this.subscription = this.intuneService.mobileConfigurationSubject$.subscribe(
      (mobileConfig: MobileConfiguration) => {
        let cloudStorageToggle = true;
        if (mobileConfig?.hasOwnProperty('CloudStorageToggle')) {
          cloudStorageToggle =
            mobileConfig && mobileConfig?.CloudStorageToggle === false ? false : true;
        }
        if (mobileConfig?.CloudStorage && typeof mobileConfig.CloudStorage === 'object') {
          this.accountPages.forEach((data) => {
            data.isVisible = mobileConfig.CloudStorage[data.label] === false ? false : true;
          });
        } else {
          this.accountPages.map((data) => {
            data.isVisible = true;
            return data;
          });
          cloudStorageToggle = mobileConfig?.CloudStorage === false ? false : true;
        }
        this.cloudStorageToggle = cloudStorageToggle;
        this.cdrRef.detectChanges();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this._destroying$.next();
    this._destroying$.complete();
    if (Capacitor.getPlatform() === 'android') {
      ScreenOrientation.removeAllListeners();
    }
  }

  async ngOnInit() {
    this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
            msg.eventType === EventType.LOGIN_SUCCESS
        ), //
        takeUntil(this._destroying$)
      )
      .subscribe({
        next: async (result: EventMessage) => {
          // Do something with event payload here
          const service = await this.storageSvc.get(STORAGE_CONST.MSAL_LOGIN);
          if (service === EMAIL_ACCOUNT_TYPE.onedrive || service === EMAIL_ACCOUNT_TYPE.office365) {
            this.isCloudLoggedIn = true;
            await this.storageSvc.remove(STORAGE_CONST.MSAL_LOGIN);
            const payload: any = result.payload;
            this.storageSvc.set(
              STORAGE_CONST.SERVICE_ACCOUNT_ID(service),
              payload?.account?.username
            );
            this.navCtrl.navigateForward('app/add-files/onedrive-list');
          } else if (
            service === EMAIL_ACCOUNT_TYPE.hotmail ||
            service === EMAIL_ACCOUNT_TYPE.outlook ||
            service === EMAIL_ACCOUNT_TYPE.office
          ) {
            this.isCloudLoggedIn = true;
            this.storageSvc.remove(STORAGE_CONST.MSAL_LOGIN);
            const payload: any = result.payload;
            //email-hotmail-id
            const id = payload?.account?.username ?? '';
            this.storageSvc.set(service, payload?.account?.username);
            await this.accounts.setEmailAccount(id, service, {
              email: payload?.account?.username,
            });
            this.navCtrl.navigateForward('app/add-files/email-accounts');
          }
        },
        error: (error) => {
          console.log('error ====>', error);
        },
      });

    await this.platform
      .ready()
      .then(async () => {
        //setting language
        this.languageService.setInitialAppLanguage();
        this.googleService.initGoogleLogin();
        this.registerHardwareBackButton();
        this.accountStateService.init();
        await this.domainSvc.loadDomainInfo();
        this.deviceInfo = await Device.getInfo();
        if (Capacitor.getPlatform() === 'android') {
          this.handleOrientationChange();
          ScreenOrientation.addListener('screenOrientationChange', () => this.handleOrientationChange());
          if (this.deviceInfo.androidSDKVersion >= SDK_VERSION_FOR_ANDROID_15) {
            document.body.classList.add('android-15-plus');
          }
        }
        if (this.platform.is('capacitor')) {
          await this.firebaseCrashlyticsService.setEnabled();
        } else {
          this.route.queryParams.subscribe((params) => {
            this.domainSvc.handleParams(params);
          });
        }
        await this.intuneService.setLatestMdmProfile();
        setTimeout(async () => {
          if (Capacitor.isNativePlatform() && !this.isCloudLoggedIn) {
            await this.intuneService.loadIntuneConfig();
            this.getCloudStorageConfig();
          }
        }, Capacitor.getPlatform() === 'ios' ? 1000 : 0);
        const menu = document.querySelector('ion-menu');
        if (menu) {
          menu.setAttribute('role', 'dialog');
          menu.setAttribute('aria-modal', 'true');
        }
      })
      .catch();
    this.addAppStateChangeListener();
    if (this.platform.is('capacitor')) {
      App.getInfo()
        .then((data) => {
          this.appVersion = data.version;
        })
        .catch();
    }
    // setting account only value
    const getAccountVal = await this.loginAccountService.getAccountOnly();
    if (getAccountVal) {
      this.sharedSvc.accountOnly = JSON.parse(getAccountVal)?.value ?? false;
    }
    // const appInfo = await App.getInfo();
    await this.doCheckStorageAccountStatus();
    this.sharedSvc.checkStorageAccountStatus.subscribe((event) => {
      if (event) {
        this.doCheckStorageAccountStatus();
      }
    });
    this.accountSvc.accountStateChanged.subscribe((account) => {
      switch (account[0]) {
        case ADD_FILE_OPTION_NAME.Google_Drive: //"Google Drive":
          if (this.accountPages[0].isEnabled !== account[1]) {
            this.accountPages[0].isEnabled = account[1];
          }
          break;
        case ADD_FILE_OPTION_NAME.Box: //"Box":
          if (this.accountPages[1].isEnabled !== account[1]) {
            this.accountPages[1].isEnabled = account[1];
          }
          break;
        case ADD_FILE_OPTION_NAME.One_Drive: //"One Drive":
          if (this.accountPages[2].isEnabled !== account[1]) {
            this.accountPages[2].isEnabled = account[1];
          }
          break;
        case ADD_FILE_OPTION_NAME.Drop_Box: //"Drop Box":
          if (this.accountPages[3].isEnabled !== account[1]) {
            this.accountPages[3].isEnabled = account[1];
          }
          break;
        case ADD_FILE_OPTION_NAME.Office_365: //"Office 365":
          if (this.accountPages[4].isEnabled !== account[1]) {
            this.accountPages[4].isEnabled = account[1];
          }
          break;
      }
    });

    this.accountSvc.redirectedAccount.subscribe(async (refreshAccounts) => {
      if (refreshAccounts) {
        this.accountPages[0].isEnabled = (await this.accountSvc.getGoogleDriveAccount())
          ? true
          : false;
        this.accountPages[1].isEnabled = (await this.accountSvc.getBoxAccount()) ? true : false;
        this.accountPages[2].isEnabled = (await this.accountSvc.getOneDriveAccount())
          ? true
          : false;
        this.accountPages[3].isEnabled = (await this.accountSvc.getDropBoxAccount()) ? true : false;
        this.accountPages[4].isEnabled = (await this.accountSvc.getOffice365Account())
          ? true
          : false;
      }
    });
  }

  addAppStateChangeListener() {
    App.addListener('appStateChange', async ({ isActive }) => {
      if (isActive) {
        this.doCheckStorageAccountStatus();
      }
    });
    // Removed Double Tap zoom
    let lastTouchEnd = 0;
    document.addEventListener(
      'touchend',
      (event) => {
        const now = Date.now();

        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }

        lastTouchEnd = now;
      },
      { passive: false }
    );
  }
  async doCheckStorageAccountStatus() {
    let promises = await Promise.all([
      await this.accountSvc.getGoogleDriveAccount(),
      await this.accountSvc.getBoxAccount(),
      await this.accountSvc.getOneDriveAccount(),
      await this.accountSvc.getDropBoxAccount(),
      await this.accountSvc.getOffice365Account(),
    ]);
    this.zone.run(async () => {
      this.accountPages.forEach((account, index) => {
        account.isEnabled = promises[index] ? true : false;
      });
    });
  }

  async confirmSwitchToggle(title: string, enabled: boolean, index: number) {
    if(enabled){
      const header = this.translateService.instant('OPEN_SIGN_IN_WINDOW_ALERT');
      const yes = this.translateService.instant('CONTINUE');
      const no = this.translateService.instant('CANCEL');
      const alertResp = await this.alertService.customAlert(header, '', '', [
        {
          text: no,
          role: 'no',
          handler: async () => {
            await alertResp.dismiss();
            this.accountPages[index].isEnabled = !enabled;
          },
        },
        {
          text: yes,
          role: 'yes',
          handler: async () => {
            await alertResp.dismiss();
            this.switchToggle(title, enabled);
          },
        },
      ]);
    }else this.switchToggle(title, enabled);
  }

  async switchToggle(title: string, enabled: boolean) {
    const accountCheckers: Record<string, () => Promise<User>> = {
      [ADD_FILE_OPTION_NAME.One_Drive]: () => this.accountSvc.getOneDriveAccount(),
      [ADD_FILE_OPTION_NAME.Box]: () => this.accountSvc.getBoxAccount(),
      [ADD_FILE_OPTION_NAME.Drop_Box]: () => this.accountSvc.getDropBoxAccount(),
      [ADD_FILE_OPTION_NAME.Office_365]: () => this.accountSvc.getOffice365Account(),
      [ADD_FILE_OPTION_NAME.Google_Drive]: () => this.accountSvc.getGoogleDriveAccount(),
    };
    const accountChecker = accountCheckers[title];
    if (accountChecker) {
      const accountExists = await accountChecker();
      if (!!accountExists !== enabled) {
        this.sharedSvc.isNavigateFromUpload = false;
        this.accountSvc.accountStateChanged.next([title, enabled]);
        if (enabled) {
          this.menuCtrl.close();
        }
      }
    }

    return false;
  }

  navigateToAbout() {
    this.navCtrl.navigateForward('about-page');
  }
  navigateToAccounts() {
    this.navCtrl.navigateForward('accounts');
  }
  navigateToLanguages() {
    this.navCtrl.navigateForward('language');
  }
  accountOnlyHandler() {
    this.sharedSvc.accountOnly = !this.sharedSvc.accountOnly;
    this.loginAccountService.setAccountOnly(this.sharedSvc.accountOnly);
  }
  supportMailTo() {}

  async navigateToSelectAccount(type) {
    const accountList = this.loginAccountService.currentLocAtionAuthenticatedAccount$.getValue();
    if (accountList.length === 1) {
      const allAccount = (await this.loginAccountService.read()) ?? [];
      allAccount.map(
        (acc, i) => (acc.activeAccount = !!acc?.ssoConfirmationResp && acc.id === accountList[0].id)
      );
      await this.loginAccountService.update(allAccount);
      this.navCtrl.navigateForward(type);
    } else {
      this.navCtrl.navigateForward('select-account', {
        state: type,
      });
    }
  }

  public registerHardwareBackButton() {
    this.platform.backButton.subscribeWithPriority(0, async () => {
      let isModalClosed = false;
      let isPopOverClosed = false;
      if (await this.modalController?.getTop()) {
        const modal = await this.modalController.getTop();
        if (modal) {
          this.modalController.dismiss();
          isModalClosed = true;
        }
      }
      if (await this.popoverController?.getTop()) {
        const popover = await this.popoverController.getTop();
        if (popover) {
          this.popoverController.dismiss();
          isPopOverClosed = true;
        }
      }
      if (!isModalClosed && !isPopOverClosed) {
        if (this.routerOutlet && this.routerOutlet.canGoBack()) {
          this.backCount = 0;
          this.routerOutlet.pop();
        } else if (this.router.url === '/app/add-files') {
          if (this.backCount == 0) {
            this.backCount++;
            this.toastService.presentToast(this.translateService.instant('PRESS_AGAIN'), 2000);
          } else if (this.backCount == 1) {
            App.exitApp();
          }
          setTimeout(() => {
            this.backCount = 0;
          }, 3000);
        }
      }
    });
  }

  isTermPage() {
    return window.location.pathname === '/terms';
  }

  async handleOrientationChange() {
    try {
      StatusBar.setStyle({ style: Style.Dark });
      await NavigationBar.setNavigationBarColor({ color: NAV_BAR_COLOR, darkButtons: true });
    } catch (error) {
      console.log('Error handling orientation change:', error);
    }
  }
}
